import { ShoppingCart, Banknote, MapPinned } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { HomeSection, HomeSectionHeader } from "@/components/home/HomeSection";

/** Keep the 3 strongest reasons — buy, sell, find a supplier. */
const BENEFITS = [
  { icon: ShoppingCart, titleKey: "home.why1_title", descKey: "home.why1_desc" },
  { icon: Banknote, titleKey: "home.why2_title", descKey: "home.why2_desc" },
  { icon: MapPinned, titleKey: "home.why3_title", descKey: "home.why3_desc" },
];

export function HomeWhy() {
  const { t } = useLang();

  return (
    <HomeSection tone="white" testId="home-why">
      <HomeSectionHeader
        kicker={t("home.why_kicker")}
        title={t("home.why_title")}
        subtitle={t("home.why_lead")}
      />

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">
        {BENEFITS.map(({ icon: Icon, titleKey, descKey }) => (
          <div
            key={titleKey}
            className="rounded-2xl border border-matpro-border bg-matpro-section/80 p-5 text-center transition-[background-color,border-color,transform] duration-200 hover:scale-[1.01] hover:border-matpro-green/40 hover:bg-white sm:text-left"
          >
            <div className="mb-4 mx-auto inline-flex h-10 w-10 items-center justify-center rounded-xl bg-matpro-green-light text-matpro-green sm:mx-0">
              <Icon className="h-5 w-5" strokeWidth={2} />
            </div>
            <h3 className="font-heading text-lg font-bold text-matpro-anthracite">
              {t(titleKey)}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-matpro-anthracite-muted">
              {t(descKey)}
            </p>
          </div>
        ))}
      </div>
    </HomeSection>
  );
}
